import styled from 'styled-components';

import { BodyM } from '@sorare/core/src/atoms/typography';
import { Color } from '@sorare/core/src/style/types';

export const ButtonText = styled(BodyM)<{ color?: Color }>`
  color: ${({ color }) => color || 'var(--c-neutral-1000)'};
`;
